<template>
  <div>
    <div class="product-stage-action-buttons">
      <div
          class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm"
          @click="runAutoBindProducts()"
          data-toggle="tooltip" data-placement="bottom"
          title="Próbuje powiązać niepowiązane dotychczas lokalne kartoteki towarów z centralnymi kartotekami towarów."
      >
        <i class="fas fa-sync-alt"/>
        Powiąż automatycznie
      </div>
    </div>
    <div class="drugstores-products-stage">

      <div class="row">
        <SearchBar2
            :searchOptions="fieldsAvailableForSearch"
            @searchRequest="searchOnList($event)"
        />
      </div>

      <div class="row">
        <div class="form-group">
          <label for="showOnlyUnBound" style="margin-right:4px!important">Pokaż tylko niepowiązane</label>
          <input type="checkbox" id="showOnlyUnBound" v-model="showOnlyUnBound"/>
        </div>
      </div>


      <div class="drugstores-products-table-container">
        <div>
          <CommonTable2
              :table="tableData"
              :rowIdentifier="rowIdentifierKey"
              @onItemAction="runAction($event)"
              @onSort="sort($event)"
              @onMassAction="runMassAction($event)"
              @onCheckItem="checkAction($event)"
              :key="refreshTable"
              :currentPage="currentPage"
              :totalRows="commonModule.getRawDrugstoresProductsDataTotal"
              :totalPages="commonModule.getRawDrugstoresProductsPagesCount"
              :showPaginationTop="true"
              :showPaginationBottom="true"
              @onPageChange="currentPage = $event"
              :sortColumn="sortingKey"
              :sortDirection="sortingDirection"
              :stickyScrollbarBottom="0"
          />
        </div>


      </div>


    </div>
    <b-modal
        v-model="showLocalDrugstoresProductsModal"
        id="local-product-info-form-modal"
        scrollable
        :title="productDetailsModalTitle"
        title-class="font-18"
        hide-footer
        size="lg"
        style="z-index:99999!important;"
        @hide="currentSelectedLocalProductData = null"

    >
      <CommonObjectSimplePrintPage id="show-product-data-pdf" ref="show-product-data-pdf"
                                   :objectToPrint="currentSelectedLocalProductData || {}" title="tOWAR lokalny"/>
    </b-modal>

    <b-modal
        v-model="showSelectCentralProductModal"
        id="central-product-binding-form-modal"
        scrollable
        title="Powiąż z centralną kartoteką towary"
        title-class="font-18"
        size="xl"
        style="z-index:100010!important;"
        ok-title="Powiąż"
        @ok="runBindWithProduct()"
        cancel-title="Anuluj"

    >
      <div class="form-group">
        <label>{{bindProductTitleMessage}}</label>
        <div v-if="showSelectCentralProductModal">
          <ProductDataList :multiselect="false" @onSelect="selectCentralProductToBind"
          :showRowActions="false"
          :showMassActions="false"
          />
        </div>
      </div>


    </b-modal>


  </div>

</template>


<script>
import CommonTable2 from "@/components/widgets/CommonTable2";
import {BModal} from "bootstrap-vue-next";
import SearchBar2 from "@/components/widgets/SearchBar2.vue";
import {log} from "@/state/pinia/log";
import CommonObjectSimplePrintPage from "@/components/widgets/CommonObjectSimplePrintPage.vue";
import ProductDataList from "./ProductDataList.vue";
import {productsHelperMethods} from "./helper/productsHelperMethods";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {mapStores} from "pinia";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";


export default {
  name: "DrugstoresProductsLocalDataList",
  props: {},
  components: {
    ProductDataList,
    CommonObjectSimplePrintPage,
    BModal,
    SearchBar2,
    CommonTable2
  },
  data() {
    return {
      rowIdentifierKey: "data_row_id",
      tableData: {},
      currentPage: 1,
      sortingDirection: "ASC",
      sortingKey: "NAZWA_TOWARU",
      searchRequest: {
        searchPhrase: null,
        searchKey: null,
      },
      localProductsRows: [],
      availableHeaders: [],
      tableMassActions: [
        {
          text: "Powiąż ręcznie z centralnym towarem",
          icon: "fas fa-link",
          action: "bind-with-central-product",
          class: "btn btn-success table-actions-button edit-button",
          enabled: true,
        },
        {
          text: "Powiąż automatycznie",
          icon: "fas fa-sync-alt",
          action: "create-bind-with-central-product",
          class: "btn btn-success table-actions-button edit-button",
          enabled: true,
        },
        {
          text: "Usuń powiązania",
          icon: "fas fa-link-slash",
          action: "remove-central-product-binding",
          class: "btn btn-warning table-actions-button edit-button",
          enabled: true,
        }
      ],
      rowActions: [
        {
          text: "",
          icon: "fas fa-window-maximize",
          action: "view-local-product-details",
          class: "btn btn-info btn-sm table-actions-button edit-button",
          enabled: true,
          tooltip: "Zobacz szczególy towaru lokalnego w aptece",
        },


      ],
      productsVisibleHeaders: ["id_kamsoft_dost", "data_row_id", "id_apteki", "nazwa_towaru", "bloz","ean","producent", "nazwa_kartoteki_centralnej_towaru"],
      drugstoresLocalProductsVisibleHeadersTitlesMap: {
        "bloz": "Bloz",
        "data_row_id": "IdLocal",
        "id_apteki": "Apteka",
        "nazwa_towaru": "Nazwa towaru",
        "ean": "EAN",
        "producent": "Producent",
        "nazwa_kartoteki_centralnej_towaru": "Centralny towar"

      },
      fieldsAvailableForSearch: [],
      showOnlyUnBound: false,
      refreshTable: true, //added key to force re-rendering
      showLocalDrugstoresProductsModal: false,
      showSelectCentralProductModal: false,
      currentSelectedLocalProductData: null,
      productDetailsModalTitle: "Dane towary lokalnego",
      localIdsSelected: [],
      selectedCentralProductGuidToBind: null,
      bindProductTitleMessage: "Wybierz centralnego towar do powiązania z towarem lokalnym:",

    };
  },
  computed: {
        simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {

    searchOnList(searchRequest) {
      this.searchRequest = searchRequest;
      this.refreshLocalProductsData();
    },
    runAction(event) {

      if (event.action.action === "view-local-product-details") {
        productsHelperMethods.showLocalProductDetails(event.itemData, this.rowIdentifierKey, this.localProductsRows).then((responsePayload) => {
          this.productDetailsModalTitle = responsePayload.productDetailsModalTitle;
          this.showLocalDrugstoresProductsModal = responsePayload.showLocalDrugstoresProductsModal;
          this.currentSelectedLocalProductData = responsePayload.currentSelectedLocalProductData;
        });

      } else if (event.action.action === "remove-central-product-binding") {
        productsHelperMethods.unBindCentralProduct([event.itemData[this.rowIdentifierKey]], this.rowIdentifierKey, this.localProductsRows).then((responsePayload) => {
          if (responsePayload.isConfirmed) {
            this.refreshLocalProductsData();

          }
        });

      } else if (event.action.action === "bind-with-central-product") {
        this.selectedCentralProductGuidToBind = null;
        productsHelperMethods.bindWithCentralProduct(event.itemData, this.rowIdentifierKey, this.localProductsRows).then((responsePayload) => {
          this.showSelectCentralProductModal = responsePayload.showSelectCentralProductModal;
          this.currentSelectedLocalProductData = responsePayload.currentSelectedLocalProductData;
        });

      } else if (event.action.action === "create-bind-with-central-product") {
        productsHelperMethods.createAndBindProducts([event.itemData[this.rowIdentifierKey]]).then(() => {
          this.currentSelectedLocalProductData = null;
          this.selectedCentralProductGuidToBind = null;

        });
      } else {
        productsHelperMethods.showNoProductDataWarning(event.itemData[this.rowIdentifierKey])
      }

    },

    refreshLocalProductsData() {
      this.lazyloaderModule.setProgressBarMessage("Pobieranie danych o towarach lokalnych w aptekach.");
      return this.commonModule.httpGetRawDrugstoresProductsHeaders().then(() => {
        this.refreshTable = false;
        return productsHelperMethods.refreshLocalProductsList(this.rowActions,this.drugstoresLocalProductsVisibleHeadersTitlesMap,this.productsVisibleHeaders,this.currentPage,this.sortingKey,
            this.sortingDirection,this.searchRequest,this.showOnlyUnBound,null).then((responsePayload) => {
          this.availableHeaders = responsePayload.availableHeaders;
          this.localProductHeaders = responsePayload.localProductHeaders;
          this.localProductsRows = responsePayload.localProductsRows;
          this.tableData = {
            headers: this.localProductHeaders,
            data: this.localProductsRows,
            massActions: this.tableMassActions
          }

        }).then(() => {
          this.refreshTable = true;
          this.lazyloaderModule.setDisplayLazyLoader(true);
          productsHelperMethods.refreshFieldsAvailableForSearch(this.availableHeaders,this.drugstoresLocalProductsVisibleHeadersTitlesMap).then((responsePayload) => {
            this.fieldsAvailableForSearch = responsePayload.fieldsAvailableForSearch;
          });
        });
      });
    },

    runAutoBindProducts(){
      productsHelperMethods.autoBindProducts()
    },

    selectCentralProductToBind(products) {
      if (products.length === 0) {
        return;
      }

      this.selectedCentralProductGuidToBind = products[0];
    },
    runBindWithProduct(){
      productsHelperMethods.bindWithProduct(this.localIdsSelected,this.rowIdentifierKey,this.currentSelectedLocalProductData,this.selectedCentralProductGuidToBind);
      this.currentSelectedLocalProductData = null;
      this.selectedCentralProductGuidToBind = null;
      this.showSelectCentralProductModal = false;
    },


    runMassAction(event) {
      log.log(event);
      if (event.action.action === "bind-with-central-product") {
        productsHelperMethods.showBindWithCentralProductModal(event.items, this.rowIdentifierKey, this.localProductsRows).then((result) => {
          this.showSelectCentralProductModal = result.showSelectCentralProductModal;
        });

      } else if (event.action.action === "remove-central-product-binding") {
        productsHelperMethods.unBindCentralProduct(event.items, this.rowIdentifierKey, this.localProductsRows).then((responsePayload) => {
          if (responsePayload.isConfirmed) {
            this.refreshLocalProductsData();
          }
        });
      } else if (event.action.action === "create-bind-with-central-product") {
        productsHelperMethods.createAndBindProducts(event.items).then(() => {
          this.currentSelectedLocalProductData = null;
          this.selectedCentralProductGuidToBind = null;

        });
      }
    },

    sort(sortKey) {
      log.log(sortKey);
      this.sortingKey = sortKey;
      this.refreshLocalProductsData();
      this.toggleSortingDirection();
    },
    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },
    checkAction(event) {
      this.localIdsSelected = event.items
    },


  },
  watch: {
    currentPage: {
      handler() {
        this.refreshLocalProductsData();
      },
      deep: true,
    },

    showOnlyUnBound: {
      handler() {
        this.refreshLocalProductsData();
      },
      deep: true,
    },


  },
  mounted() {

  },
  created() {
    this.refreshLocalProductsData();


  },
};
</script>

<style scoped>
.drugstores-products-stage {
  margin-left: 16px;
  margin-right: 16px;
}

.drugstores-products-table-container {
}

.drugstores-products-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
}

.table-success {
  background-color: #d4edda;
  color: #155724;
}


.table-info {
  background-color: #d4edda;
  color: #152c57;
}

.table-warning {
  background-color: #fff3cd;
  color: #856404;
}

.table-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.product-stage-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
}


</style>
